import styled from 'styled-components'

export const Title = styled.h5`
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: ${(p) => p.theme.colors.defaultLightActive};
  display: flex;
  align-items: center;
`
